<template>
  <main class="page-operative page-operative-data-analysis page-operative-data-analysis-cogs page-operative-data-analysis-cogs-new">
    <div class="container-fluid">
      <div class="d-flex align-items-center justify-content-between mb-5">
        <PageTitle>Nuovo progetto</PageTitle>
        <app-router-link class="btn btn-outline-primary" :to="{ name: 'operative-company.projects.list' }">Torna alla lista</app-router-link>
      </div>

      <template v-if="company">
        <div v-if="!userCanEdit">Utente non abilitato</div>
        <div v-else-if="!projectTemplateSelected">
          <div class="row">
            <div class="col"><button class="btn btn-primary" @click.prevent="selectTemplate(null)">Senza modello</button></div>
          </div>
          <div class="row mt-3" v-for="projectTemplate in projectTemplates" :key="projectTemplate.id">
            <div class="col"><button class="btn btn-primary" @click.prevent="selectTemplate(projectTemplate.id)">Da modello: {{ projectTemplate.name }}</button></div>
          </div>
        </div>
        <FormProject v-else :project="project" :personnel="personnel" :libraryCosts="libraryCosts" :libraryImputedCosts="libraryImputedCosts" @saved="saveProject" />
      </template>
    </div>
  </main>
</template>

<script>

import operativePageMixin from '@/mixins/operativePage';

export default {
  name: 'page-operative-company-data-analysis-cogs-new',
  mixins: [operativePageMixin],
  components: {
    PageTitle: () => import('@/views/components/Layout/LayoutOperative/PageTitle'),
    FormProject: () => import('@/views/components/Operative/Form/FormProject'),
    AppRouterLink: () => import('@/views/components/Layout/AppRouterLink'),
  },
  data () {
    return {
      projectTemplateSelected: false,
      project: undefined,
      projectTemplates: [],
      personnel: [],
      libraryCosts: [],
      libraryImputedCosts: [],
    };
  },
  methods: {
    selectTemplate (templateId) {
      if (templateId) {
        const projectTemplate = this.projectTemplates.find(pt => pt.id === templateId);
        if (projectTemplate) {
          this.project = {
            ...projectTemplate,
            costs: projectTemplate.costs.map(c => {
              return {
                name: c.cost?.name || null,
                measurementUnit: c.cost?.measurementUnit || null,
                vat: parseInt(c.cost?.vat || 0) || 0,
                ritenuta: parseInt(c.cost?.ritenuta || 0) || 0,
                unitCost: parseInt(c.unitCost || c.cost?.unitCost || 0) || 0,
                quantity: parseInt(c.quantity || 0) || 0,
              };
            }),
            imputedCosts: projectTemplate.imputedCosts.map(c => {
              return {
                cost: c.cost,
                costId: c.cost?.id || null,
                name: c.cost?.name || null,
                quantity: parseInt(c.quantity || 0) || 0,
              };
            }),
            personnel: projectTemplate.personnelCosts.map(c => {
              return {
                cost: c.cost,
                costId: c.cost?.id || null,
                name: c.cost?.name || null,
                hours: parseInt(c.quantity || 0) || 0,
                monthlyHours: [],
              };
            }),
          };
        }
      }

      this.projectTemplateSelected = true;
    },
    saveProject (project) {
      if (!this.projectTemplateSelected) {
        return;
      }

      this.$api.addProject(this.company.id, project)
        .then(() => {
          this.$router.push({
            name: 'operative-company.projects.list',
            query: {
              forecast: this.$route.query?.forecast || null,
            },
          });
        })
        .catch(this.$log.error)
      ;
    },
  },
  watch: {
    company: {
      immediate: true,
      handler: function () {
        if (!this.company) {
          return;
        }

        this.$api.getCostiPersonale(this.company.id)
          .then(res => {
            this.personnel = res.data?.costi || [];
          })
          .catch(this.$log.error)
        ;

        this.$api.listProjectLibraryCosts(this.company.id)
          .then(res => {
            this.libraryCosts = res.data?.costs || [];
          })
          .catch(this.$log.error)
        ;

        this.$api.listImputedCosts(this.company.id)
          .then(res => {
            this.libraryImputedCosts = res.data?.costs || [];
          })
          .catch(this.$log.error)
        ;

        this.$api.listProjectLibraryTemplates(this.company.id, true)
          .then(res => {
            this.projectTemplates = res.data.templates;
          })
          .catch(this.$log.error)
        ;
      },
    },
  },
};

</script>
